module.exports = __webpack_public_path__ + "img/hedwig-icon.88e756b3.png";